/**
 * Created by mly on 2017/12/19.
 */
const flow_util = {
    userFlowNodeUserStatusHtml(user_flow_node_user, user_flow_node) {
        const user_status = user_flow_node_user.status;
        const node_status = user_flow_node.status;
        const action_type = user_flow_node_user.action_type;
        let text = '';
        switch (action_type) {
            case 'submit':
                switch (user_status) {
                    case 0:
                        text = '编辑中';
                        break;
                    case 1:
                        text = '提交';
                        break;
                    case 2:
                        text = '驳回';
                        break;
                    case 3:
                        text = 'HOLD';
                        break;
                    default:
                        text = '未定义审批状态';
                        break;
                }
                break;
            case 'handle':
                switch (user_status) {
                    case 0:
                        text = node_status !== 2 ? '待处理' : '未处理';
                        break;
                    case 1:
                        text = '已处理';
                        break;
                    case 2:
                        text = '驳回';
                        break;
                    case 3:
                        text = 'HOLD';
                        break;
                    default:
                        text = '未定义审批状态';
                        break;
                }
                break;
            case 'check':
                switch (user_status) {
                    case 0:
                        text = node_status !== 2 ? '待审核' : '未审核';
                        break;
                    case 1:
                        text = '通过';
                        break;
                    case 2:
                        text = '驳回';
                        break;
                    case 3:
                        text = 'HOLD';
                        break;
                    default:
                        text = '未定义审批状态';
                        break;
                }
                break;
            case 'finish':
                switch (user_status) {
                    case 0:
                        text = node_status !== 2 ? '待处理' : '未处理';
                        break;
                    case 1:
                        text = '已完成';
                        break;
                    case 2:
                        text = '驳回';
                        break;
                    case 3:
                        text = 'HOLD';
                        break;
                    default:
                        text = '未定义审批状态';
                        break;
                }
                break;
            case 'confirm':
                switch (user_status) {
                    case 0:
                        text = node_status !== 2 ? '待确认' : '未确认';
                        break;
                    case 1:
                        text = '确认';
                        break;
                    case 2:
                        text = '驳回';
                        break;
                    case 3:
                        text = 'HOLD';
                        break;
                    default:
                        text = '未定义审批状态';
                        break;
                }
                break;
            default:
                text = '未定义审核类型';
                break;
        }
        switch (user_status) {
            case 0:
                text = node_status !== 2 ? `<span class="color-info">${text}</span>` : `<span class="color-grey">${text}</span>`;
                break;
            case 1:
                text = `<span class="color-success">${text}</span>`;
                break;
            case 2:
                text = `<span class="color-error">${text}</span>`;
                break;
            case 3:
                text = `<span class="color-warning">${text}</span>`;
                break;
            default:
                text = `<span class="color-error">${text}</span>`;
                break;
        }
        return text;
    },
    canEdit(model, cur_customer) {
        return flow_util.canHandleWithActionType(model, cur_customer, 'submit');
    },
    canFinish(model, cur_customer) {
        return flow_util.canHandleWithActionType(model, cur_customer, 'finish');
    },
    canHandleWithActionType(model, cur_customer, action_type) {
        if (model.del) return false;
        const user_flow = model.user_flow;
        const node_users = flow_util.getCurUserFlowNodeUsers(user_flow);
        let ret = false;
        node_users.forEach((node_user) => {
            const is_cur_user = node_user.customer_id === cur_customer.id;
            const is_editor = node_user.action_type === action_type;
            if (is_cur_user && is_editor) {
                ret = true;
            }
        });
        return ret;
    },
    inEditNode(model) {
        if (!model.id) return true;
        if (model.del) return false;
        const user_flow = model.user_flow;
        if (!user_flow) return false;
        if (user_flow.is_finish) return false;
        const node_users = flow_util.getCurUserFlowNodeUsers(user_flow);
        let ret = false;
        node_users.forEach((node_user) => {
            const is_editor = node_user.action_type === 'submit';
            if (is_editor) {
                ret = true;
            }
        });
        return ret;
    },
    inEditNodes(model, nodeNames) {
        if (!model.id) return true;
        if (model.del) return false;
        const user_flow = model.user_flow;
        if (!user_flow) return false;
        const node_users = flow_util.getCurUserFlowNodeUsers(user_flow);
        const current_node_name = flow_util.getCurFlowNodeName(user_flow);
        let ret = nodeNames.indexOf(current_node_name) !== -1;
        node_users.forEach((node_user) => {
            const is_editor = node_user.action_type === 'submit';
            if (is_editor) {
                ret = true;
            }
        });
        return ret;
    },
    inFinishNode(model) {
        if (model.del) return false;
        const user_flow = model.user_flow;
        const node_users = flow_util.getCurUserFlowNodeUsers(user_flow);
        let ret = false;
        node_users.forEach((node_user) => {
            const is_editor = node_user.action_type === 'finish';
            if (is_editor) {
                ret = true;
            }
        });
        return ret;
    },
    isFinished(model) {
        if (model.del) return false;
        const user_flow = model.user_flow;
        if (!user_flow) return true;
        return user_flow.is_finish;
    },
    getCurUserFlowNodeUsers(user_flow) {
        if (!user_flow) return [];
        const user_flow_nodes = user_flow.user_flow_nodes;
        const cur_user_node = user_flow_nodes ? user_flow_nodes[0] : user_flow.current_user_flow_node;
        if (!cur_user_node) return [];
        const node_users = cur_user_node.user_flow_node_users;
        if (!node_users) return [];
        return node_users;
    },
    getPassText(action_type) {
        let pass_text = '';
        switch (action_type) {
            case 'submit':
                pass_text = '提交';
                break;
            case 'handle':
                pass_text = '处理';
                break;
            case 'check':
                pass_text = '通过';
                break;
            case 'confirm':
                pass_text = '确认';
                break;
            case 'finish':
                pass_text = '完成';
                break;
            default:
                pass_text = '[错误]未定义审核类型';
                break;
        }
        return pass_text;
    },
    /*
     * 获取flow信息
     * params
     * model_name
    */
    getFlowInfo(model_name) {
        if (!model_name) {
            console.error('请指定你需要获取的流程说对应的model');
        }
        return new Promise((resolve, reject) => {
            Util.ajax.get(Util.api.get_flow_by_link_model, {
                params: {
                    link_model: model_name
                }
            }).then((response) => {
                return response.data;
            }).then((res) => {
                if (res.code === 1) {
                    const flow_info = res.data;
                    resolve(flow_info);
                } else {
                    reject({message: res.msg});
                }
            }).catch((e) => {
                reject(e);
            });
        });
    },
    getUserFlowInfo(id) {
        return new Promise((resolve, reject) => {
            Util.ajax.get(Util.api.user_flow_detail, {
                params: {
                    id: id
                }
            }).then((response) => {
                return response.data;
            }).then((res) => {
                if (res.code === 1) {
                    resolve(res.data.user_flow);
                } else {
                    reject({message: res.msg});
                }
            }).catch((e) => {
                reject(e);
            });
        });
    },
    getUserFlowBaseInfo(id) {
        return new Promise((resolve, reject) => {
            Util.ajax.get(Util.api.user_flow_base, {
                params: {
                    id: id
                }
            }).then((response) => {
                return response.data;
            }).then((res) => {
                if (res.code === 1) {
                    resolve(res.data.user_flow);
                } else {
                    reject({message: res.msg});
                }
            }).catch((e) => {
                reject(e);
            });
        });
    },
    getCurFlowNodeName(user_flow) {
        if (user_flow && user_flow.current_user_flow_node) {
            return user_flow.current_user_flow_node.flow_node.name;
        } else {
            return ''
        }
    },
};

export default flow_util;
